module.exports = __webpack_public_path__ + "static/media/1026227.44d1a1a2.jpg";